export const TERMS_RESOURCE_NAME = "searched_terms";

export const CONTEXT_SUBCAT_SEARCH = "sub-category search";
export const CONTEXTS = [CONTEXT_SUBCAT_SEARCH].map((f) => ({
  value: f,
  label: f,
}));
